export var SpecialChar;
(function (SpecialChar) {
    SpecialChar["EmDash"] = "\u2014";
})(SpecialChar || (SpecialChar = {}));
//# sourceMappingURL=special-char.enum.js.map